import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Wrapper = styled(Box)({
  width: '100%',
});

export const ImageWrapper = styled(Box)(({ theme }) => ({
  zIndex: 0,
  '& div': {
    minHeight: '770px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    // backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  [theme.breakpoints.down('md')]: {
    '& img': {
      objectPosition: 'center',
    },
  },
  [theme.breakpoints.up('lg')]: {
    // flexGrow: 1,
    // '& img': {
    //   objectPosition: 'top',
    //   objectFit: 'cover',
    //  },
  },
}));

export const ImageBackground = styled(Box)({
  width: '100% !important',
  // maxWidth: '480px !important',
  minWidth: 'auto !important',
});
